import Button from "../../../../../../common/components/atom/Button/Button";
import PhoneInput from "../../../../../../common/components/atom/CountryCodeInput/CountryCodeInput";
import SelectInput from "../../../../../../common/components/atom/SelectInput/SelectInput";
import TextInput from "../../../../../../common/components/atom/TextInput/TextInput";
import MessageCard from "../../../../../../common/components/molecule/MessageCard/MessageCard";
import { FormError, UserFormData } from "../NewUserFormPresenter";
import styles from "./NewAdminUserFormView.module.scss";

export interface NewUserFormPresenterViewProps {
  userFormData: UserFormData;
  setUserFormData: (userFormData: UserFormData) => void;
  messageError?: string;
  handleSubmit?: () => void;
  isLoading?: boolean;
  isDisabledSubmit?: boolean;
  title?: string;
  TitleRender?: () => JSX.Element;
  description?: string;
  errorStatus?: FormError;
  isUserExist?: boolean;
}

/**
 * New user form view
 * @param param0
 * @returns
 */
export default function NewUserFormPresenterView({
  userFormData,
  setUserFormData,
  messageError,
  handleSubmit,
  isDisabledSubmit,
  isLoading,
  title,
  TitleRender,
  description = "Saisissez vos informations et créer votre nouveau compte",
  errorStatus,
  isUserExist,
}: NewUserFormPresenterViewProps) {
  return (
    <div className={[styles["container-global"]].join(" ")}>
      <h1 className={[styles["container__title"]].join(" ")}>
        {title}
        {TitleRender && <TitleRender />}
      </h1>
      <p className={[styles["container__description"]].join(" ")}>
        {description}
      </p>
      <div className={[styles["container__error-message"]].join(" ")}>
        <MessageCard variant="danger" message={messageError} width100 />
      </div>
      <form
        className={[styles["form"]].join(" ")}
        onSubmit={(e) => {
          e.preventDefault();
          handleSubmit && handleSubmit();
        }}
      >
        {!isUserExist && (
          <div className={[styles["form__item"]].join(" ")}>
            <SelectInput
              options={[
                { value: "MALE", label: "Monsieur" },
                { value: "FEMALE", label: "Madame" },
                { value: "OTHER", label: "Autre" },
              ]}
              label="Genre"
              value={userFormData.gender}
              handleChange={(value) => {
                setUserFormData({ ...userFormData, gender: value });
              }}
              error={errorStatus?.isGenderError}
            />
          </div>
        )}

        <div className={[styles["form__item"]].join(" ")}>
          <TextInput
            label="Nom"
            value={userFormData.lastname}
            onChange={(e) => {
              setUserFormData({ ...userFormData, lastname: e.target.value });
            }}
            error={errorStatus?.isLastnameError}
            disabled={isUserExist}
          />
        </div>
        <div className={[styles["form__item"]].join(" ")}>
          <TextInput
            label="Prénom"
            value={userFormData.firstname}
            onChange={(e) => {
              setUserFormData({ ...userFormData, firstname: e.target.value });
            }}
            error={errorStatus?.isFirstnameError}
            disabled={isUserExist}
          />
        </div>
        <div className={[styles["form__item"]].join(" ")}>
          <TextInput
            label="Email"
            value={userFormData.email}
            onChange={(e) => {
              setUserFormData({ ...userFormData, email: e.target.value });
            }}
            error={errorStatus?.isEmailError}
            disabled={isUserExist}
            type="email"
          />
        </div>
        {!isUserExist && (
          <>
            <div className={[styles["form__item"]].join(" ")}>
              <PhoneInput       value={userFormData.numberPhone}
                onChange={(e) => {
                  setUserFormData({
                    ...userFormData,
                    numberPhone: e,
                  });}}
                     error={errorStatus?.isNumberPhoneError}
                  />

            </div>

            <div className={[styles["form__item"]].join(" ")}>
              <TextInput
                label="Mot de passe"
                value={userFormData.password}
                type="password"
                withShowPasswordBtn
                onChange={(e) => {
                  setUserFormData({
                    ...userFormData,
                    password: e.target.value,
                  });
                }}
                error={errorStatus?.isPasswordError}
          
              />
            </div>
            <div className={[styles["form__item"]].join(" ")}>
              <TextInput
                label="Confirmation du mot de passe"
                value={userFormData.passwordConfirmation}
                type="password"
                onChange={(e) => {
                  setUserFormData({
                    ...userFormData,
                    passwordConfirmation: e.target.value,
                  });
                }}
                withShowPasswordBtn
                error={errorStatus?.isPasswordConfirmationError}
              />
            </div>
          </>
        )}
        <div className={[styles["form__button-container"]].join(" ")}>
          <div className={[styles["form__button-container__item"]].join(" ")}>
            <Button
              isLoading={isLoading}
              type={"submit"}
              disabled={isDisabledSubmit}
            >
              {!isUserExist ? "Créer un compte" : "Intégrer l'organisation"}
            </Button>
          </div>
        </div>
      </form>
    </div>
  );
}
